export default {
  namespaced: true,
  actions: {
    name: "Ação | Ações",
    accept: "Aceitar",
    add: "Adicionar",
    edit: "Editar",
    delete: "Eliminar",
    cancel: "Cancelar",
    filter: "Filtro | Filtros",
    update: "Atualizar",
    export: "Exportar",
    close: "Fechar",
    save: "Salvar",
    save_changes: "Salvar alterações",
    send: "Enviar",
    download: "Baixar",
    reset: "Reiniciar",
    drag_drop_1: "Arraste e solte para fazer upload de conteúdo!",
    drag_drop_2: "...ou clique para selecionar um arquivo do seu computador",
    load: "Carregar",
    refresh: "Atualizar",
    next: "Próximo",
    previous: "Anterior",
    go_back: "Voltar",
    finish: "Terminar",
    delete_all: "Excluir tudo",
    select_deselect_all: "Selecionar/Desselecionar tudo",
    validate: "Validar",
    sync: "Sincronizar",
    synchronizing: "Sincronizando",
    showMore: "Veja mais",
    clone: "Clonar",
    show: "Mostrar",
    refresh_table: "Atualizar Tabela",
    collapse: "Recolher",
    expand: "Expandir",
    start: "Iniciar",
    stop: "Parar",
    pause: "Pausar",
    approve: "Aprovar",
    reject: "Rejeitar",
    status: "Estado",
    exit: "Sair",
    syncing: "Sincronizando",
    saving: "Salvando",
    loading: "Carregando",
    view_document: "Visualizar documento",
    search: "Pesquisar",
    file_upload: {
        accepted_types_label: "Tipos aceitos:",
        accepted_types_value: "Imagens, PDF, Word, Excel, PowerPoint.",
        max_label: "Máximo:",
        max_per_document: "30 MB por documento",
        max_documents_total: "5 documentos no total",
        tooltip: "Imagens: JPG, JPEG, PNG, GIF, BMP, WEBP, SVG<br>Documentos: PDF<br>Word: DOC, DOCX, ODT, RTF<br>Excel: XLS, XLSX, CSV, ODS",
        select_files: "Selecionar arquivos...",
        browse: "Examinar",
        max_documents_error: "Máximo {n} documentos permitidos",
        max_size_error: "{name}: excede o tamanho máximo de {n} MB",
        uploading: "Enviando arquivo(s)...",
        deleting: "Excluindo arquivo...",
    },
    download_document: "Baixar documento",
  },
};
